// istanbul ignore file — composition shell; logic lives in hooks, slices, and child modules.

import { CalendlyContacts } from '@calendly/ui/components/glyphs/CalendlyContacts'
import { CalendlyContactsFilled } from '@calendly/ui/components/glyphs/CalendlyContactsFilled'
import { CalendlyNotetaker } from '@calendly/ui/components/glyphs/CalendlyNotetaker'
import { CalendlyNotetakerFilled } from '@calendly/ui/components/glyphs/CalendlyNotetakerFilled'
import { IconAffiliate } from '@calendly/ui/components/glyphs/IconAffiliate'
import { IconAffiliateFilled } from '@calendly/ui/components/glyphs/IconAffiliateFilled'
import { IconBell } from '@calendly/ui/components/glyphs/IconBell'
import { IconBellFilled } from '@calendly/ui/components/glyphs/IconBellFilled'
import { IconBuildings } from '@calendly/ui/components/glyphs/IconBuildings'
import { IconCalendar } from '@calendly/ui/components/glyphs/IconCalendar'
import { IconCalendarEvent } from '@calendly/ui/components/glyphs/IconCalendarEvent'
import { IconCalendarEventFilled } from '@calendly/ui/components/glyphs/IconCalendarEventFilled'
import { IconCalendarFilled } from '@calendly/ui/components/glyphs/IconCalendarFilled'
import { IconDashboard } from '@calendly/ui/components/glyphs/IconDashboard'
import { IconDashboardFilled } from '@calendly/ui/components/glyphs/IconDashboardFilled'
import { IconKey } from '@calendly/ui/components/glyphs/IconKey'
import { IconKeyFilled } from '@calendly/ui/components/glyphs/IconKeyFilled'
import { IconLink } from '@calendly/ui/components/glyphs/IconLink'
import { IconLinkFilled } from '@calendly/ui/components/glyphs/IconLinkFilled'
import { IconLock } from '@calendly/ui/components/glyphs/IconLock'
import { IconLockFilled } from '@calendly/ui/components/glyphs/IconLockFilled'
import { IconMail } from '@calendly/ui/components/glyphs/IconMail'
import { IconMailFilled } from '@calendly/ui/components/glyphs/IconMailFilled'
import { IconPalette } from '@calendly/ui/components/glyphs/IconPalette'
import { IconPaletteFilled } from '@calendly/ui/components/glyphs/IconPaletteFilled'
import { IconPhone } from '@calendly/ui/components/glyphs/IconPhone'
import { IconPhoneFilled } from '@calendly/ui/components/glyphs/IconPhoneFilled'
import { IconReceipt } from '@calendly/ui/components/glyphs/IconReceipt'
import { IconReceiptFilled } from '@calendly/ui/components/glyphs/IconReceiptFilled'
import { IconSettings } from '@calendly/ui/components/glyphs/IconSettings'
import { IconSettingsFilled } from '@calendly/ui/components/glyphs/IconSettingsFilled'
import { IconShieldLock } from '@calendly/ui/components/glyphs/IconShieldLock'
import { IconShieldLockFilled } from '@calendly/ui/components/glyphs/IconShieldLockFilled'
import { IconSparkles2 } from '@calendly/ui/components/glyphs/IconSparkles2'
import { IconSparkles2Filled } from '@calendly/ui/components/glyphs/IconSparkles2Filled'
import { IconStar } from '@calendly/ui/components/glyphs/IconStar'
import { IconStarFilled } from '@calendly/ui/components/glyphs/IconStarFilled'
import { IconUsers } from '@calendly/ui/components/glyphs/IconUsers'
import { IconUserSquareRounded } from '@calendly/ui/components/glyphs/IconUserSquareRounded'
import { IconWorld } from '@calendly/ui/components/glyphs/IconWorld'
import { IconWorldFilled } from '@calendly/ui/components/glyphs/IconWorldFilled'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { colorIconActionContrast, colorIconStandard } from '@calendly/ui/theme'

import { SETTINGS_SECTION } from './constants'
import { getSettingsIconIdForSection } from './settingsConfig'

const SETTINGS_NAV_ICON_BY_SECTION = {
  [SETTINGS_SECTION.profile]: {
    icon: IconUserSquareRounded,
    selectedIcon: IconUserSquareRounded,
  },
  [SETTINGS_SECTION.branding]: { icon: IconPalette, selectedIcon: IconPaletteFilled },
  [SETTINGS_SECTION.workflows]: { icon: IconBell, selectedIcon: IconBellFilled },
  [SETTINGS_SECTION.contacts_settings]: {
    icon: CalendlyContacts,
    selectedIcon: CalendlyContactsFilled,
  },
  [SETTINGS_SECTION.security]: { icon: IconLock, selectedIcon: IconLockFilled },
  [SETTINGS_SECTION.adminOrganization]: {
    icon: IconBuildings,
    selectedIcon: IconBuildings,
  },
  [SETTINGS_SECTION.adminPeople]: {
    icon: IconUsers,
    selectedIcon: IconUsers,
  },
  [SETTINGS_SECTION.adminDashboard]: { icon: IconDashboard, selectedIcon: IconDashboardFilled },
  [SETTINGS_SECTION.adminBilling]: { icon: IconReceipt, selectedIcon: IconReceiptFilled },
  [SETTINGS_SECTION.adminSecurity]: { icon: IconShieldLock, selectedIcon: IconShieldLockFilled },
  [SETTINGS_SECTION.adminManagedEventTypes]: { icon: IconCalendarEvent, selectedIcon: IconCalendarEventFilled },
}

/**
 * @type {Record<string, {
 *   icon: import('react').ComponentType<any>,
 *   selectedIcon: import('react').ComponentType<any>,
 * }>}
 */
const SETTINGS_NAV_ICON_BY_ID = {
  user: { icon: IconUserSquareRounded, selectedIcon: IconUserSquareRounded },
  calendar: { icon: IconCalendar, selectedIcon: IconCalendarFilled },
  star: { icon: IconStar, selectedIcon: IconStarFilled },
  palette: { icon: IconPalette, selectedIcon: IconPaletteFilled },
  organization: { icon: IconBuildings, selectedIcon: IconBuildings },
  link: { icon: IconLink, selectedIcon: IconLinkFilled },
  phone: { icon: IconPhone, selectedIcon: IconPhoneFilled },
  sparkle: { icon: IconSparkles2, selectedIcon: IconSparkles2Filled },
  notetaker: { icon: CalendlyNotetaker, selectedIcon: CalendlyNotetakerFilled },
  gear: { icon: IconSettings, selectedIcon: IconSettingsFilled },
  contacts: {
    icon: CalendlyContacts,
    selectedIcon: CalendlyContactsFilled,
  },
  lock: { icon: IconLock, selectedIcon: IconLockFilled },
  mail: { icon: IconMail, selectedIcon: IconMailFilled },
  users: { icon: IconUsers, selectedIcon: IconUsers },
  groups: { icon: IconAffiliate, selectedIcon: IconAffiliateFilled },
  dashboard: { icon: IconDashboard, selectedIcon: IconDashboardFilled },
  access: { icon: IconKey, selectedIcon: IconKeyFilled },
  billing: { icon: IconReceipt, selectedIcon: IconReceiptFilled },
  'org-branding': { icon: IconPalette, selectedIcon: IconPaletteFilled },
  domain: { icon: IconWorld, selectedIcon: IconWorldFilled },
  'admin-lock': { icon: IconShieldLock, selectedIcon: IconShieldLockFilled },
  'managed-events': { icon: IconCalendarEvent, selectedIcon: IconCalendarEventFilled },
}

const SettingsModalNavIcon = ({ active, iconPair }) => {
  const Idle = iconPair?.icon ?? IconSettings
  const Selected = iconPair?.selectedIcon ?? IconSettingsFilled
  const IconComponent = active ? Selected : Idle
  const color = active ? colorIconActionContrast : colorIconStandard

  return (
    <UiIcon
      color={color}
      icon={IconComponent}
      size="medium"
      title=""
    />
  )
}

/**
 * Leading icon for settings modal nav rows. Icon id comes from `settingsConfig`; components resolve here.
 */
export const SettingsNavIcon = ({ section, active }) => {
  const iconPair = SETTINGS_NAV_ICON_BY_SECTION[section] ?? SETTINGS_NAV_ICON_BY_ID[getSettingsIconIdForSection(section)]

  return (
    <SettingsModalNavIcon
      active={active}
      iconPair={iconPair}
    />
  )
}
